import { useState } from "react";
import styles from "./devicefilter.module.css";
import { Link } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ArrowRight, Filter, Key, Plus, Search, Smartphone } from "react-feather";
import { Dropdown } from "react-bootstrap";

const DeviceFilter = ({ filterData, setFilterData, setShowAddFormNew, setShowAddFormNew2 }) => {
    const [filterOpen, setFilterOpen] = useState(false);

    return <div className={`${styles.NotesSearchArea}`}>
        <div className={`${styles.FilterSearchSec}`}>
            <div className={`${styles.NotesSearchMain}`}>
                <Search />
                <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; })} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Status"
                            value={filterData?.status}
                            onChange={(e) => {
                                setFilterData((prev) => {
                                    return { ...prev, status: e.target.value };
                                });
                            }}
                        >
                            <MenuItem value={"all"}>All</MenuItem>
                            <MenuItem value={1}>Online</MenuItem>
                            <MenuItem value={0}>Offline</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Location</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Location"
                            onChange={(e) => {
                                setFilterData((prev) => {
                                    return { ...prev, location: e.target.value };
                                });
                            }}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="Bathroom">Bathroom</MenuItem>
                            <MenuItem value="Bedroom">Bedroom</MenuItem>
                            <MenuItem value="Bedroom Closet">Bedroom Closet</MenuItem>
                            <MenuItem value="Living Room">Living Room</MenuItem>
                            <MenuItem value="Living Room Closet">Living Room Closet</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width250} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label"> Product</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Product"
                            value={filterData?.product}
                            onChange={(e) => {
                                setFilterData((prev) => {
                                    return { ...prev, product: e.target.value };
                                });
                            }}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="Propertydek-Door Lock">Door Lock</MenuItem>
                            <MenuItem value="Propertydek-Light">Dimmer</MenuItem>
                            <MenuItem value="Propertydek-Thermostat">Thermostat</MenuItem>
                            <MenuItem value="Propertydek-Lock Gateway">Lock Gateway</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            <Dropdown>
                <Dropdown.Toggle
                    className={`${styles.ActionsBU} ${styles.Red} ActionsBU Red`} id="dropdown-basic">
                    <Plus /> <span className={`${styles.AddBuText}`}>Device</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setShowAddFormNew(true)}>
                        <Smartphone /> Tuya Device
                    </Dropdown.Item>
                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setShowAddFormNew2(true)}>
                        <Key /> TTLock Device
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    </div>;
}

export default DeviceFilter;